import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiTrendingUp, FiLock } = FiIcons;

const Hero = () => {
  const scrollToConsultation = () => {
    const element = document.getElementById('consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen overflow-hidden">
      {/* Video Background with Gradient Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/80 to-slate-900/80 z-10"></div>
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute w-full h-full object-cover"
          loading="lazy"
          preload="metadata"
        >
          <source src="https://s3.us-east-1.wasabisys.com/createspace/Namvoro-Hero-video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center lg:text-left"
          >
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Protect Your Brand. Power Your Presence.
            </h1>
            <p className="text-xl text-slate-300 mb-8 leading-relaxed">
              Namvoro delivers secure, enterprise-grade digital brand management — from domains to DNS and beyond.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={scrollToConsultation}
                className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-emerald-700 transition-colors duration-200 shadow-xl"
              >
                Request a Consultation
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-slate-900 transition-all duration-200"
              >
                Learn More
              </motion.button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative z-10 bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <div className="grid grid-cols-3 gap-6 mb-8">
                <div className="text-center">
                  <SafeIcon icon={FiShield} className="w-8 h-8 text-emerald-400 mx-auto mb-2" />
                  <p className="text-white text-sm font-medium">Secure</p>
                </div>
                <div className="text-center">
                  <SafeIcon icon={FiTrendingUp} className="w-8 h-8 text-emerald-400 mx-auto mb-2" />
                  <p className="text-white text-sm font-medium">Scalable</p>
                </div>
                <div className="text-center">
                  <SafeIcon icon={FiLock} className="w-8 h-8 text-emerald-400 mx-auto mb-2" />
                  <p className="text-white text-sm font-medium">Protected</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-slate-300">Domain Security</span>
                  <div className="w-16 h-2 bg-emerald-500 rounded-full"></div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-300">DNS Management</span>
                  <div className="w-20 h-2 bg-emerald-500 rounded-full"></div>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-slate-300">Email Protection</span>
                  <div className="w-14 h-2 bg-emerald-500 rounded-full"></div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Subtle Animated Elements */}
      <div className="absolute inset-0 z-[5] pointer-events-none">
        <div className="absolute top-1/4 left-1/5 w-32 h-32 border border-emerald-500/20 rounded-full animate-pulse-slow"></div>
        <div className="absolute top-1/3 right-1/4 w-24 h-24 border border-emerald-500/20 rounded-full animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-16 h-16 border border-emerald-500/20 rounded-full animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
      </div>
    </section>
  );
};

export default Hero;